import classes from "../Styling/SharedStyling.module.css"

import React, { useEffect, useState } from 'react';
import mockup1 from '../Images/TheJobHuntScreenshots/Home_Screen.png';
import mockup2 from '../Images/TheJobHuntScreenshots/Applied_Screen.png';
import mockup3 from '../Images/TheJobHuntScreenshots/Attributes_Screen.png';
import mockup4 from '../Images/TheJobHuntScreenshots/Contacts_Screen.png';
import mockup5 from '../Images/TheJobHuntScreenshots/Notes_Screen.png';
import mockup6 from '../Images/TheJobHuntScreenshots/History_Screen.png';
import mockup7 from '../Images/TheJobHuntScreenshots/Offer_Screen.png';

export default function TheJobHuntPage()
{
  const thresholdWidth = 1000; // MUST BE CHANGED IN TANDEM WITH CSS

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function leadingImageLayout(text: String, imgSource: string)
  {
    return (
      <div className={classes.container}>
        <div className={classes.halfContainerTJH}>
          <img alt="iPhone Mockup Showing Feature" className={classes.mockupLeft} src={imgSource}></img>
        </div>
        <h2 className={classes.mockupTextRightTJH}>{text}</h2>
      </div>
    );
  }

  function trailingImageLayout(text: String, imgSource: string)
  {
    return (
      windowDimensions.width > thresholdWidth ?
        <div className={classes.container}>
          <h2 className={classes.mockupTextLeftTJH}>{text}</h2>
          <div className={classes.halfContainerTJH}>
            <img alt="iPhone Mockup Showing Feature" className={classes.mockupRight} src={imgSource}></img>
          </div>
        </div>
        : 
        leadingImageLayout(text, imgSource)
    );
  }

  return (
    <div>
      <div className={classes.appDetailsWrapper}>
        <h1 className={classes.appName}>THE JOB HUNT</h1>
        <a className={classes.appLinkTJH} target={"_blank"} href="https://apps.apple.com/mk/app/the-job-hunt/id1543936415">learn more</a>        
      </div>

      {leadingImageLayout("Keep Track Of Job Applications At A Glance...", mockup1)}
      {trailingImageLayout("Keep Everything About A Role In One Place...", mockup2)}
      {leadingImageLayout("Add Custom Attributes...", mockup3)}
      {trailingImageLayout("Built-In Contacts...", mockup4)}
      {leadingImageLayout("Built-In Notes...", mockup5)}
      {trailingImageLayout("Automatically Assembles History From Updates...", mockup6)}
      {leadingImageLayout("Secure The Offer.", mockup7)}
    </div>
    );
}